import React from 'react';
import { Typography } from '@mui/material';
import CarrierSupplierMapTable from '../tables/CarrierSupplierMapTable';

const CarrierSupplierMapSection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        Carrier ID / Supplier ID Mapping
      </Typography>
      <CarrierSupplierMapTable />
    </>
  );
};

export default CarrierSupplierMapSection;
